<script>
    export let customHeader;
    export let image;
    export let title;
    export let content;
    export let video;
    export let gallery;
    export let logo;
    
    let active = false;
    let infoname = false;
    let hiddenInfoName;

    import { fly } from 'svelte/transition';
    
    import { createEventDispatcher, onMount } from 'svelte';
    const dispatch = createEventDispatcher();

    import UA from 'ua-parser-js';
    const ua = new UA();
    const is_mobile = ua.getResult().device['type'] == 'mobile';

    onMount(()=>{
        if(!is_mobile){ openSceneInfo(); }
    });

    /*____________ Krpano Events ____________*/
    addEventListener('krpano:infoclick', (e)=>{  
        console.log(e.detail);
        openHotspotInfo(e.detail.hotspot)
    });

    addEventListener('krpano:newpano', (e)=>{
        console.log(e.detail); 
        if(!is_mobile){ openSceneInfo(); }
    });

    addEventListener('krpano:gridtoggle', (e)=>{ 
        console.log(e.detail);
        if(e.detail.grid == true){
            return closeSidebar();
        }
    });

    /*____________ Methods ____________*/
    function getCurrentSceneInfoHotspot(){
        let sceneName = window.CC.krpano.get('xml.scene');
        let scene = window.CC.krpano.get(`scene[${sceneName}]`);
        return scene.info ? scene.info : false           
    }

    function  hideHotspot(hotspotName){
        hiddenInfoName = hotspotName;
        window.CC.krpano.set('hotspot['+hotspotName+'].visible', false);
    }

    function showHiddenHotspot(){
        if(hiddenInfoName){
            window.CC.krpano.set('hotspot['+hiddenInfoName+'].visible', true);
            hiddenInfoName = null;
        }
    }

    function openSceneInfo(){
        let infoName = getCurrentSceneInfoHotspot();
        
        if(infoName){
            console.log(infoName)
            let hsContent = getHotspotContent(infoName)
            changeContent(hsContent);
            openSidebar(infoName);
        } else {
            console.log('NO INFO SET ON SCENE')
            closeSidebar();
        }
    }

    function openHotspotInfo(hotspotName){
        let hotspotContent = getHotspotContent(hotspotName)
        changeContent(hotspotContent);
        openSidebar(hotspotName);
    }

    function changeContent(infoContent){
        if(typeof infoContent === 'string'){
            let  hotspotName = infoContent;
            infoContent = getHotspotContent(hotspotName);
        }

        title = infoContent.title;
        content = infoContent.content;
        image = infoContent.image;
        video = infoContent.video;
        gallery = infoContent.gallery;
        customHeader = infoContent.header;
        infoname = infoContent.name
    }

    function openSidebar(hs){
        active = true;
        infoname = hs;
        hideHotspot(hs);
        console.log(infoname);
    }

    function closeSidebar(){
        active = false;
        infoname = false;
        showHiddenHotspot();
        

        title = null;
        content = null;
        image = null;
        video = null;
        gallery = null;
        customHeader = null;
        infoname = null;

        console.log(infoname);
    }

    // parses krpano html content
    function parseContent(content){
        return content
            .replaceAll('[', '<')
            .replaceAll(']', '>')
    }
    
    // gets content from krpano hotspot
    function getHotspotContent(hotspotName){
        let hotspot = window.CC.krpano.get('hotspot['+hotspotName+']');
        let galleryName = hotspot.gallery;
        let hotspotGallery;

        if(galleryName){
            let galleryArr = window.CC.krpano.get('gallery['+galleryName+']').img.getArray()
            hotspotGallery = galleryArr.map((item)=>{
                return item.url.replace('%SWFPATH%', '.');
            });
        }

        let header = null;
        if(hotspot.header){
            header = parseContent(hotspot.header);
        }

        return {
            name: hotspot.name,
            title: parseContent(hotspot.title),
            image: hotspot.image,
            video: hotspot.video,
            gallery: hotspotGallery,
            header: header,
            content: parseContent(hotspot.text),
        }
    }

    function dispatchVideo(e){
        if(video){
            dispatch('loadvideo', { video: video });
        }
    }
</script>


<!-- /*____________ Markup ____________*/ -->
{#if infoname}
    {#key infoname}
    <div class="info-sidebar" transition:fly={{x: -1000, duration: 1000, opacity: 1 }}>
            <div class="close" on:click={closeSidebar}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 125" version="1.1" x="0px" y="0px"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g fill="#000000"><path d="M76.01775,72.48275 C76.99475,73.45975 76.99475,75.04175 76.01775,76.01775 C75.52975,76.50575 74.88975,76.75075 74.24975,76.75075 C73.61075,76.75075 72.97075,76.50575 72.48275,76.01775 L49.87475,53.41075 L27.26775,76.01775 C26.77975,76.50575 26.13975,76.75075 25.49975,76.75075 C24.86075,76.75075 24.22075,76.50575 23.73275,76.01775 C22.75575,75.04175 22.75575,73.45975 23.73275,72.48275 L46.33975,49.87575 L23.73275,27.26775 C22.75575,26.29175 22.75575,24.70975 23.73275,23.73275 C24.70875,22.75575 26.29075,22.75575 27.26775,23.73275 L49.87475,46.33975 L72.48275,23.73275 C73.45875,22.75575 75.04075,22.75575 76.01775,23.73275 C76.99475,24.70975 76.99475,26.29175 76.01775,27.26775 L53.41075,49.87575 L76.01775,72.48275 Z"/></g></g></svg>
            </div>
            <div class="container">
                <header class="header">
                    {#if customHeader}
                        {@html customHeader}
                    {:else}
                        {#if logo}
                        <div class="logo"><img src={logo} /></div>
                        {/if}
                    {/if}
                </header>
                <img on:click={dispatchVideo} class="image" class:has-video={video} src="{image}" alt={video ? 'Play Video' : ''} width="100%"/>
                <h2 class="title">{@html title}</h2>
                
                <div class="content">
                    {#if customHeader}
                        <h2 class="title">{title}</h2>
                    {/if}
                    {@html content}
                </div>

                {#if gallery}
                    <div class="gallery">
                        {#each gallery as galleryImage }
                        <div class="gallery-image-container">
                            <img class="gallery-image" src="{galleryImage}" alt="" width="100%"/>
                        </div>
                        {/each}
                    </div>
                {/if}
                <div class="close-bottom" on:click={closeSidebar}>Close</div>
            </div>
        </div>
    {/key}
{/if}

<!-- /*____________ CSS ____________*/ -->
<style>
    .close {
        position: absolute;
        top: 7px;
        right: 7px;
        width: 45px;
        height: 45px;
        z-index: 400;
        cursor: pointer;
    }

    .close:hover {
        width: 50px;
        top: 5px;
        right: 5px;
    }

    .close-bottom {
        text-align: center;
        font-weight: 900;
        color: #fff;
        background: #000;
        border-radius: 5px;
        padding: 1rem 1.5rem;
        cursor: pointer;
        margin-top: 0.5rem;
        text-transform: uppercase;
        border: 2px solid transparent;
        background: #571900;
    }

    .close-bottom:hover {
        background: #fff;
        color: #000;
        border: 2px solid #240a00;
    }

    .info-sidebar {
        transition: 1s all ease;
        position: fixed;
        z-index: 1000;

        top: 0;
        left: 0;

        height: 100%;
        overflow-y: scroll;
        width: 400px;

        background: #fff;
        color: #222;
        line-height: 1.5rem;

        font-family: 'Raleway', sans-serif;
        text-align: left;
        padding: 0;
        margin: 0;
    }

    ::-webkit-scrollbar {
    width: 6px;
    }
    ::-webkit-scrollbar-thumb {
    background: #571900;
    }

    ::-webkit-scrollbar-thumb:hover{
        background: #240a00;
    }


    .has-video {
        cursor: pointer;
    }

    .container {
        padding: 2rem;
    }

    header.header :global(img) {
        width: 100%;
        margin: 1rem 0;
    }

    .logo {
        margin-bottom: 1rem;
    }

    .logo img{
        width: 250px;
        margin: auto;
        display: block;
    }

    .title {
        text-align: center;
    }

    .hide {
        opacity: 0;
    }

    @media only screen and (max-width: 600px) {     
        .logo img {
            width: 200px;
        }

        .info-sidebar {
            width: 100%;
            height: 100%;
            z-index: 9999;
        }
    }
</style>
